module.exports = __webpack_public_path__ + "img/clock.34dadf1d.svg";